import { render, staticRenderFns } from "./Nursery.vue?vue&type=template&id=506cefed"
import script from "./Nursery.vue?vue&type=script&lang=js"
export * from "./Nursery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports